export default "__VITE_ASSET__DZHflhp6__"